import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { Loader } from "./webWorkers/LoaderFile/Loader";

const FilterModal = ({
  showFilterModal,
  setShowFilterModal,
  filterType,
  setFilterType,
  filterOptions,
  selectedFilterOptions,
  handleFilterChange,
  handleSelectFilterChange,
  handleApplyFilter,
  handleResetFilter,
  searchText,
  setSearchText,
  isLoaderApply
}) => {
  return (
    <Modal
      show={showFilterModal}
      onHide={() => setShowFilterModal(false)}
      className="overflow-hidden"
    >
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Form className="d-flex justify-content-around mb-2">
            <Form.Check
              type="radio"
              label="Year"
              name="filterType"
              value="year"
              checked={filterType === "year"}
              onChange={() => handleFilterChange("year")}
            />
            <Form.Check
              type="radio"
              label="Author"
              name="filterType"
              value="author"
              checked={filterType === "author"}
              onChange={() => handleFilterChange("author")}
            />
            <Form.Check
              type="radio"
              label="Journal"
              name="filterType"
              value="journal"
              checked={filterType === "journal"}
              onChange={() => handleFilterChange("journal")}
            />
            <Form.Check
              type="radio"
              label="Title"
              name="filterType"
              value="journal"
              checked={filterType === "title"}
              onChange={() =>  setFilterType("title")}
            />
          </Form>
          <Select
            isDisabled={filterType === "title"}
            options={filterOptions}
            isMulti
            value={selectedFilterOptions}
            onChange={handleSelectFilterChange}
            closeMenuOnSelect={true}
            placeholder="Select filter options..."
          />
          {filterType === "title" && (
            <input
              type="text"
              placeholder="Search by title..."
              className="form-control"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={
            (filterType !== "title" && selectedFilterOptions.length === 0) ||
            (filterType === "title" && searchText.length === 0)
          }
          variant="secondary"
          onClick={handleResetFilter}
        >
          Reset
        </Button>
        <Button
         disabled={
          (filterType !== "title" && selectedFilterOptions.length === 0) ||
          (filterType === "title" && searchText.length === 0)
        }
          variant="primary"
          onClick={handleApplyFilter}
        >
         {isLoaderApply ? "Applying Filter...." : "Apply Filter" }  
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;
